import React from 'react'
import { useQuery } from '../hooks/useQuery'

const withLocationSuggestions = BaseComponent => props => {
    const operation = 'locationSuggestions'
    const defaultVariables = {
        prefix: { value: '', required: true },
    }
    const fields = ['description', 'structured_formatting', 'matched_substrings', 'place_id', 'types']

    const { data, refetch, loading } = useQuery(operation, defaultVariables, {
        lazy: true,

    }, fields)

    // TODO
    const clearSuggestions = () => { }
    // TODO

    return (
        <BaseComponent
            {...props}
            suggestions={data ? data : []}
            getAutocompleteResults={(params) => {
                refetch(params)
            }}
            isPerformingSearch={loading}
            clearSuggestions={clearSuggestions}
        />
    )
}

export default withLocationSuggestions



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withLocationSuggestions.js